import  gql  from 'graphql-tag'

export const EDIT_USER = gql`mutation userUpdate($input: UserUpdateMutationInput!){
    userUpdate(input: $input){
        user{
            id
            name
            surname
            username
            email
            isActive
            authSystem
            group{
                id
                name
            }
        }
        errors{
            field
            messages
        }
    }
}`;